import { Dispatch } from "react";
import * as actionTypes from "redux/actionTypes/Index";
import {
  IActionType,
  IGetQueryParams,
  IFetchCnicVerificationActionResponse,
  ICnicVerificationRequestPayload,
} from "interfaces/Index";
import {
  getCnicVerificationDataApiCall,
  verifyCnicDataApiCall,
} from "redux/sources/CnicVerificationSource";

export const getCnicVerificationDataInit = () => ({
  type: actionTypes.GET_CNIC_VERIFICATION_DATA_INIT,
});

export const getCnicVerificationDataSuccess = (
  payload: IFetchCnicVerificationActionResponse
) => ({
  type: actionTypes.GET_CNIC_VERIFICATION_DATA_SUCCESS,
  payload,
});
export const getCnicVerificationDataFail = (error: string | object | null) => ({
  type: actionTypes.GET_CNIC_VERIFICATION_DATA_FAIL,
  error,
});

export const verifyCnicDataInit = () => ({
  type: actionTypes.VERIFY_CNIC_DATA_INIT,
});

export const verifyCnicDataSuccess = () => ({
  type: actionTypes.VERIFY_CNIC_DATA_SUCCESS,
});
export const verifyCnicDataFail = (error: string | object | null) => ({
  type: actionTypes.VERIFY_CNIC_DATA_FAIL,
  error,
});

export const getCnicVerificationDataAction =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getCnicVerificationDataInit());
    return getCnicVerificationDataApiCall(queryParams)
      .then((response) => dispatch(getCnicVerificationDataSuccess(response)))
      .catch((e) => dispatch(getCnicVerificationDataFail(e)));
  };

export const verifyCnicDataAction =
  (payload: ICnicVerificationRequestPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(verifyCnicDataInit());
    return verifyCnicDataApiCall(payload)
      .then(() => dispatch(verifyCnicDataSuccess()))
      .catch((e) => dispatch(verifyCnicDataFail(e)));
  };
